export function providerAbrev(name) {
  // const value = val.toLowerCase();
  const formatedName = name.toLowerCase();
  switch (formatedName) {
    case 'mienvio':
      return 'ME';
    case 'redpack':
      return 'RP';
    case 'ups':
      return 'U';
    case 'superenvios':
      return 'SE';
    case '99minutos':
      return '99';
    case 'paqueteexpress':
      return 'PX';
    case 'dhl':
      return 'DHL';
    case 'altospack':
      return 'AP';
    case 'sendex':
      return 'SD';
    case 'vencedor':
      return 'VR';
    case 'j&t':
      return 'J&T';

    default:
      return '-';
  }
}
